const Loading = () => {
  return (
    <div className=" absolute left-[50%] top-[50%] translate-y-[-50%] translate-x-[-50%] ">
      <div className="flex justify-center items-center h-full">
        <img
          className="h-12 w-12"
          src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
          alt=""
        />
      </div>
    </div>
  );
};
export default Loading;
